import React, { useState } from "react";
import { observer } from "mobx-react";
import "react-select-search/style.css";
import { useHistory, Link } from "react-router-dom";
import authStore from "../../../../../../Stores/AuthStore/AuthStore";
import { CheckStep } from "../../../../registration1";
import UIBlockButton, {
  UIBlockButtonColor,
} from "../../../../../../Components/Katelinlis/Button.tsx";
import { UIInputBlock } from "../UIInputBlock";
import { DirectorEduStep } from "./DirectorEduStep";

export const DirectorName = observer((props) => {
  let history = useHistory();
  if (authStore.isRegistration) {
    CheckStep("teacher");
  }

  return (
    <>
      <div
        className="RegistrationSecondStepMainContainer"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translateY(-50%) translateX(-50%)",
        }}
      >
        <h1
          style={{
            margin: "32px 0",
            fontSize: "24px",
            fontWeight: "bold",
            fontFamily:
              "'Open Sans','Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
            WebkitUserSelect: "none",
            MsUserSelect: "none",
            UserSelect: "none",
          }}
        >
          Введите личные данные
        </h1>
        <div
          className="RegistrationSecondStepContainer"
          style={{
            display: "flex",
            width: "336px",
            maxWidth: "100%",
            margin: "0 auto",
            flexDirection: "column",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <UIInputBlock
            type="text"
            placeholder="Фамилия*"
            width="336px"
            height="48px"
          />
          <UIInputBlock
            type="text"
            placeholder="Имя*"
            width="336px"
            height="48px"
            margin="24px 0"
          />
          <UIInputBlock
            type="text"
            placeholder="Отчество"
            width="336px"
            height="48px"
          />
        </div>
        <Link to="/registration/director-edu">
          <UIBlockButton
            style={UIBlockButtonColor.Primary}
            // disabled
            text="Далее"
            margin="40px 0 0 0"
          />
        </Link>
      </div>

      {/*</form>*/}
      <svg
        className="step_reg"
        width="70"
        height="10"
        viewBox="0 0 70 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="65" cy="5" r="5" fill="#434A54" />
        <circle cx="35" cy="5" r="5" fill="#434A54" fillOpacity="0.5" />
        <circle cx="5" cy="5" r="5" fill="#434A54" fillOpacity="0.5" />
      </svg>
    </>
  );
});

export default DirectorName;
